import {
    FieldInCard,
} from 'app/types/form.types'
import {
    LoggerExchangeReason, LoggerType,
} from 'app/enums/label.enums'
import {
    ContainerChangeStatus,
} from './ChangeStatus.types'

const changeStatusFields = ({
    isToBeLoggerExchanged,
    getAllowedValues,
    statusTransitions,
}): FieldInCard<keyof ContainerChangeStatus>[] => {
    const defaultFields: FieldInCard<keyof ContainerChangeStatus> = {
        title: 'CONTAINER_STATUS',
        fields: [
            {
                name: 'containerStatus',
                componentName: 'EnumSelector',
                allowedValues: statusTransitions,
                labelKey: 'CONTAINER_STATUS',
                showOutOfRangeOption: true,
            },
            {
                name: 'containerManualStatusChangeComment',
                componentName: 'LongText',
                className: 'comment',
                labelKey: 'CONTAINER_STATUS_CHANGE_COMMENT',
            },
            {
                name: 'containerStatusChangeDocumentation',
                labelKey: 'CONTAINER_STATUS_CHANGE_DOCUMENTATION',
                className: 'documentation',
                componentName: 'AttachmentsObjectSelector',
            },
            {
                name: 'containerManualStatusChangeTimestamp',
                componentName: 'DateTimeZonedSelect',
                labelKey: 'CONTAINER_STATUS_CHANGE_TIMESTAMP',
            },
        ],
    }

    return isToBeLoggerExchanged ? [{
        title: defaultFields.title,
        fields: [
            ...defaultFields.fields,
            {
                name: 'loggerExchangeReason',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(LoggerExchangeReason),
                required: true,
                labelKey: 'LOGGER_EXCHANGE_REASON',
            },
            {
                name: 'requiredLoggerExchange',
                componentName: 'MultiEnumSelector',
                allowedValues: getAllowedValues(LoggerType),
                required: true,
                labelKey: 'REQUIRED_LOGGER_EXCHANGE',
            },
        ],
    }] : [defaultFields]
}

export default changeStatusFields
